<template>
  <div class="payTabber">
    <!-- <div class="left" @click="clickCancellation">取消订单</div> -->
    <div class="right" v-if="isEffective" :class="{ 'graying' : overtime }" @click="continuePay">
      <div class="surplus">{{ currentTime }}</div>
      <div class="continue">继续支付</div>
    </div>
    <div v-else class="close" @click="againBuyingTickets">重新购票</div>
  </div>
</template>

<script>
import { getIndividualPayOrder, getGroupPayOrder } from '@/service/order/common.js';

export default {
  name: "payTabber",
  props: ['orderDetails', 'payCloseTime', 'tickettype', 'ticketlist'],
  data() {
    return {
      currentTime: '',
      overtime: false,
      isEffective: true,
      userInfo: {}
    }
  },
  created(){
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  },
  methods: {
    clickCancellation(){
      console.log('订单取消')
    },
    async continuePay(){
      const { orderId } = this.$route.query;
      let data = null;
      const parameter = {
        userId: this.userInfo.userId,
        orderId,
        payType: "WEIXIN"
      }
      if(this.tickettype === 'guideorderdetails'){
        data = await getGroupPayOrder.call(this, parameter);
      }else{
        data = await getIndividualPayOrder.call(this, parameter);
      }
      if(!data.appCode)return;
      if(this.overtime)return;
      const callback = {
        orderId,
        orderSource: 'WX',
        orderType: this.tickettype !== 'guideorderdetails' ? 0 : 1,
        returnUrl: encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/${this.tickettype}?orderId=${orderId}`),
        errorUrl: encodeURIComponent(`${process.env.VUE_APP_WECHAT_BOUNCE_BACK}#/${this.tickettype}?orderId=${orderId}`),
      };
      location.href = `${process.env.VUE_APP_BASE_URL}/unified/pay?orderId=${callback.orderId}&orderSource=${callback.orderSource}&orderType=${callback.orderType}&returnUrl=${callback.returnUrl}&errorUrl=${callback.errorUrl}`;
    },
    againBuyingTickets(){
      this.$router.push(this.ticketlist);
    }
  },
  watch:{
    payCloseTime:{
      handler(newvalue){
        let timeId = setInterval(() => {
          const date1 = new Date()
          const date2 = new Date(newvalue.replace(/-/g, '/'))
          const s1 = date1.getTime(),s2 = date2.getTime();
          const total = (s2 - s1)/1000;
          if(parseInt(total) <= 0){
            this.overtime = true;
            clearInterval(timeId)
          };
          const day = parseInt(total / (24*60*60));//计算整数天数
          const afterDay = total - day*24*60*60;//取得算出天数后剩余的秒数
          const hour = parseInt(afterDay/(60*60));//计算整数小时数
          const afterHour = total - day*24*60*60 - hour*60*60;//取得算出小时数后剩余的秒数
          const min = parseInt(afterHour/60);//计算整数分
          const afterMin = total - day*24*60*60 - hour*60*60 - min*60;//取得算出分后剩余的秒数
          this.currentTime = `剩余支付时间 ${String(parseInt(min)).padStart(2, 0)} : ${String(parseInt(afterMin)).padStart(2, 0)}`;
          if(min < 1 && afterMin < 1){
            this.isEffective = false;
          };
        }, 1000)
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped lang='less'>
.payTabber{
  height: 1.6rem;
  position: fixed;
  width: 100%;
  display: flex;
  bottom: 0;
  left: 0;
  .left{
    color: #333333;
    font-size: .426667rem;
    background: #FFFFFF;
    line-height: 1.6rem;
    padding: 0 1.066667rem;
  }
  .right{
    background: #2E92E0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .surplus{
      color: rgba(255, 255, 255, .6);
      font-size: .373333rem;
    }
    .continue{
      color: #FFFFFF;
      font-size: .24rem * 2;
      margin-top: .066667rem;
    }
  }

  .close{
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    background: #3B6D9C;
    line-height: 1.6rem;
    text-align: center;
    color: #FFFFFF;
    font-size: 0.48rem;
  }
  .graying{
    background: #A1A6BA;
  }
}
</style>
